import React, { useState } from 'react';
import classnames from 'classnames';
import get from 'get-value';
import Input from 'shared/Inputs/Input';

import InputWrapper from 'modules/af_cm_ui_kit/components/InputWrapper/InputWrapper';
import styles from './styles.module.scss';

import { FullAddressProps } from './types';
import { Button } from 'lmc-ui-library';
import { Address } from 'components/DetailsPageBoilerplate/types';

const ChangeableFullAddress: React.FC<FullAddressProps> = ({
  field,
  type,
  placeholder,
  form,
  disabled,
  handleBlur,
  title,
  subtitle,
  readOnly,
  extraContent = [],
  onChangeClick,
  onClick,
  disabledButton,
  addressValues,
}) => {
  field.value = field.value === null ? '' : field.value;

  const [initialValue, setInitialValue] = useState<Address>(addressValues);

  const shouldBeDisabled = disabledButton || addressValues === initialValue || get(form.errors, field.name);

  const handleClick = () => {
    if (shouldBeDisabled) return;

    setInitialValue(addressValues);

    return onChangeClick(field.value);
  };

  return (
    <InputWrapper
      title={title}
      name={field.name}
      subtitle={subtitle}
      hasError={false}
      wasTouched={false}
      extraContent={extraContent}>
      <div className={styles.inputContainer}>
        <Input
          field={field}
          type={type}
          className={classnames('text-input', styles.input)}
          placeholder={placeholder}
          form={form}
          disabled={disabled}
          readOnly={readOnly}
          handleBlur={handleBlur}
          onClick={onClick}
        />

        <Button
          mode="secondary"
          borderVariant="rectangle"
          type="button"
          onClick={handleClick}
          style={{ width: 106 }}
          disabled={shouldBeDisabled}>
          Change
        </Button>
      </div>
    </InputWrapper>
  );
};

export default ChangeableFullAddress;
